import store from 'store2'

import post from '../../../lib/post'

export default function(o,data,item,collection,done){

  var ombStore = store.namespace('omb')

  post(
    'data',
    {
      token: ombStore('token'),
      type: 'insert',
      collection: collection,
      item: item,
    },
    function(error, result){
      if(error){
        done(error)
      } else {
        o.sounds.beep.play()
        o.feedback.ok('document inserted')
        data.push(result.item)
        done(null,result.item)
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/documentInsert.js